import React from 'react';
import { Shareholder } from 'components/shareholder/Shareholder';

export const ShareholderSlice = ({ tagline, title, items }) => {
  const reports = items
    .filter((year) => year.annualReport?.href)
    .map((year) => (
      <Shareholder.Report key={year.title} title={year.title} link={year.annualReport} />
    ));

  return (
    <Shareholder tagline={tagline} title={title} reports={reports}>
      {items
        .filter((year) => year.documents?.length > 0)
        .map((year, i) => (
          <Shareholder.Year key={year.title} title={year.title}>
            {year.documents?.map((document) => (
              <Shareholder.Document
                key={document.title}
                title={document.title}
                link={document.link}
              />
            ))}
          </Shareholder.Year>
        ))}
    </Shareholder>
  );
};

export default ShareholderSlice;
